import React, { useState, useEffect } from 'react';
import { MdClose, MdBusiness, MdPerson, MdLocationOn, MdSave } from 'react-icons/md';
import axios from 'axios';
import { API_BASE_URL as DEFAULT_API_BASE_URL } from '../../config/api';


const EditTraderModal = ({ isOpen, onClose, trader, showPopup, fetchData, API_BASE_URL, userMmdaId, onSuccess, onError }) => {
  const [formData, setFormData] = useState({
    business_name: '',
    owner_name: '',
    phone: '',
    email: '',
    business_type: 'Retail',
    zone_id: '',
    group_id: '',
    location: '',
    registration_date: '',
    status: 'active',
  });
  const [zones, setZones] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [groupsLoading, setGroupsLoading] = useState(false);

  const config = {
    headers: {
      'Authorization': 'Basic ' + btoa('Techland:Techland@24'),
      'Content-Type': 'application/json',
    },
  };

  // Fetch zones for dropdown
  const fetchDropdownData = async () => {
    setDataLoading(true);
    try {
      const zonesRes = await axios.get(`${API_BASE_URL}/zones?userRole=MMDA&mmda_id=${userMmdaId}`, config);
      setZones(zonesRes.data);
    } catch (error) {

    } finally {
      setDataLoading(false);
    }
  };

  // Fetch groups for a specific zone
  const fetchGroupsForZone = async (zoneId) => {
    if (!zoneId) {

      setGroups([]);
      return;
    }


    setGroupsLoading(true);
    try {
      const url = `${API_BASE_URL}/zonal-groups?userRole=MMDA&mmda_id=${userMmdaId}&zone_id=${zoneId}`;

      const groupsRes = await axios.get(url, config);

      setGroups(groupsRes.data);
    } catch (error) {

      setGroups([]);
    } finally {
      setGroupsLoading(false);
    }
  };

  // Handle zone change to fetch groups
  useEffect(() => {

    if (formData.zone_id && formData.zone_id !== '') {

      fetchGroupsForZone(formData.zone_id);
    } else {

      setGroups([]);
    }
  }, [formData.zone_id]);

  // Populate form with trader data
  useEffect(() => {
    if (isOpen && trader) {
      // Clear groups first - don't load any groups initially
      setGroups([]);

      setFormData({
        business_name: trader.business_name || '',
        owner_name: trader.owner_name || '',
        phone: trader.phone || '',
        email: trader.email || '',
        business_type: trader.business_type || 'Retail',
        zone_id: trader.zone_id || '',
        group_id: trader.group_id || '',
        location: trader.location || '',
        registration_date: trader.registration_date ? trader.registration_date.split('T')[0] : '',
        status: trader.status || 'active',
      });
      fetchDropdownData();

      // Don't automatically fetch groups - wait for user to select zone
      // Groups will be loaded only when user changes the zone selection
    } else if (isOpen) {
      // Clear groups when modal opens without trader
      setGroups([]);
    }
  }, [isOpen, trader]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;


    // If zone is changing, clear the group selection
    if (name === 'zone_id') {

      setFormData(prev => ({
        ...prev,
        [name]: value,
        group_id: '' // Clear group when zone changes
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Prepare update data, converting empty strings to null for integer fields
      const updateData = {
        ...formData,
        mmda_id: parseInt(userMmdaId),
        // Convert empty strings to null for integer fields
        zone_id: formData.zone_id === '' ? null : parseInt(formData.zone_id),
        group_id: formData.group_id === '' ? null : parseInt(formData.group_id),
      };


      const response = await axios.put(`${API_BASE_URL}/traders/${trader.trader_id}`, updateData, config);

      if (response.status === 200) {
        onClose();
        
        // Show success modal
        if (onSuccess) {
          onSuccess('Updated', 'Trader', formData.business_name, 'Business information has been successfully updated.');
        } else {
          showPopup('Trader updated successfully!', 'success');
          fetchData();
        }
      }
    } catch (error) {

      
      // Show error modal
      if (onError) {
        onError('Update', 'Trader', formData.business_name, error.response?.data?.error || error.message);
      } else {
        showPopup(error.response?.data?.error || 'Failed to update trader', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {

    setFormData({
      business_name: '',
      owner_name: '',
      phone: '',
      email: '',
      business_type: 'Retail',
      zone_id: '',
      group_id: '',
      location: '',
      registration_date: '',
      status: 'active',
    });
    setGroups([]);
    setZones([]);
    onClose();
  };

  if (!isOpen || !trader) return null;

  // Debug current state


  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 600,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdBusiness size={24} style={{ color: '#ff9800' }} />
            <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Edit Business Information</h2>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 4,
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        {dataLoading ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <p>Loading form data...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* Business Information */}
            <div style={{ marginBottom: 20 }}>
              <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                <MdBusiness size={20} style={{ color: '#ff9800' }} />
                Business Information
              </h3>
              
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                    Business Name *
                  </label>
                  <input
                    type="text"
                    name="business_name"
                    value={formData.business_name}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '90%',
                      padding: '10px 12px',
                      border: '1px solid #ddd',
                      borderRadius: 6,
                      fontSize: 14,
                      outline: 'none',
                    }}
                    placeholder="Enter business name"
                  />
                </div>
                
                <div>
                  <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                    Business Type *
                  </label>
                  <select
                    name="business_type"
                    value={formData.business_type}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid #ddd',
                      borderRadius: 6,
                      fontSize: 14,
                      outline: 'none',
                    }}
                  >
                    <option value="Retail">Retail</option>
                    <option value="Wholesale">Wholesale</option>
                    <option value="Restaurant">Restaurant</option>
                    <option value="Service">Service</option>
                    <option value="Manufacturing">Manufacturing</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Owner Information */}
            <div style={{ marginBottom: 20 }}>
              <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                <MdPerson size={20} style={{ color: '#17a2b8' }} />
                Owner Information
              </h3>
              
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                    Owner Name *
                  </label>
                  <input
                    type="text"
                    name="owner_name"
                    value={formData.owner_name}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '90%',
                      padding: '10px 12px',
                      border: '1px solid #ddd',
                      borderRadius: 6,
                      fontSize: 14,
                      outline: 'none',
                    }}
                    placeholder="Enter owner's full name"
                  />
                </div>
                
                <div>
                  <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '90%',
                      padding: '10px 12px',
                      border: '1px solid #ddd',
                      borderRadius: 6,
                      fontSize: 14,
                      outline: 'none',
                    }}
                    placeholder="0241234567"
                  />
                </div>
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  style={{
                    width: '95%',
                    padding: '10px 12px',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    fontSize: 14,
                    outline: 'none',
                  }}
                  placeholder="owner@business.com (optional)"
                />
              </div>
            </div>

            {/* Location Information */}
            <div style={{ marginBottom: 20 }}>
              <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                <MdLocationOn size={20} style={{ color: '#4caf50' }} />
                Location Information
              </h3>
              
              {/* Zone Selection - Always visible */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                  Zone *
                </label>
                <select
                  name="zone_id"
                  value={formData.zone_id}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    fontSize: 14,
                    outline: 'none',
                  }}
                >
                  <option value="">Select a zone</option>
                  {zones.map(zone => (
                    <option key={zone.zone_id} value={zone.zone_id}>
                      {zone.zone_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Group Selection - Only show when zone is selected */}
              {formData.zone_id && (
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                    Group {groupsLoading ? '(Loading...)' : '(Optional)'}
                  </label>
                  <select
                    name="group_id"
                    value={formData.group_id}
                    onChange={handleInputChange}
                    disabled={groupsLoading}
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid #ddd',
                      borderRadius: 6,
                      fontSize: 14,
                      outline: 'none',
                      backgroundColor: groupsLoading ? '#f5f5f5' : 'white',
                    }}
                  >
                    <option value="">No group assigned</option>
                    {groups.map(group => (
                      <option key={group.group_id} value={group.group_id}>
                        {group.group_name}
                      </option>
                    ))}
                  </select>
                </div>
              )}


              {/* Status Selection */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                  Status *
                </label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    fontSize: 14,
                    outline: 'none',
                  }}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="suspended">Suspended</option>
                </select>
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                  Business Location/Address *
                </label>
                <textarea
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                  required
                  rows={3}
                  style={{
                    width: '95%',
                    padding: '10px 12px',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    fontSize: 14,
                    outline: 'none',
                    resize: 'vertical',
                  }}
                  placeholder="Enter detailed business address or location"
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 24 }}>
              <button
                type="button"
                onClick={handleClose}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #6c757d',
                  borderRadius: 6,
                  backgroundColor: 'white',
                  color: '#6c757d',
                  cursor: 'pointer',
                  fontSize: 14,
                  fontWeight: 'bold',
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: 6,
                  backgroundColor: loading ? '#6c757d' : '#ff9800',
                  color: 'white',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontSize: 14,
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <MdSave size={16} />
                {loading ? 'Updating...' : 'Update Business'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default EditTraderModal;
